import styled from 'styled-components';

const BaseStyle = styled.div`
  ${({ fontSize }) => `font-size: ${fontSize}`};
  font-family: 'Avenir Light', 'Arial', sans-serif;
  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
`;

export default BaseStyle;
